// extracted by mini-css-extract-plugin
export default {"cardGraphic":"nrQC3","img":"wIFXY","text":"WZtOn"};